var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sku-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "ListFilterVue",
                {
                  attrs: {
                    FILTER_ITEMS: _vm.FILTER_ITEMS,
                    handleSearch: _vm.handleSearch,
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:export:excel:sku"],
                          expression: "['admin:export:excel:sku']",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        icon: "el-icon-upload2",
                        plain: "",
                        type: "primary",
                      },
                      on: { click: _vm.resultExports },
                    },
                    [_vm._v("\n            结果导出\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:export:excel:out"],
                          expression: "['admin:export:excel:out']",
                        },
                      ],
                      staticClass: "mr10",
                      attrs: {
                        size: "mini",
                        icon: "el-icon-upload2",
                        plain: "",
                        type: "primary",
                      },
                      on: { click: _vm.foreignExports },
                    },
                    [_vm._v("对外导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          path: "/store/list/creatProduct",
                          query: { source: "sku" },
                        },
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["admin:product:sku:save"],
                              expression: "['admin:product:sku:save']",
                            },
                          ],
                          attrs: { size: "mini", type: "primary" },
                        },
                        [_vm._v("添加商品")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": true,
                "header-cell-style": { fontWeight: "bold" },
                "max-height": "600",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "SKU ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.attrImage
                          ? _c(
                              "div",
                              { staticClass: "demo-image__preview" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "36px",
                                    height: "36px",
                                  },
                                  attrs: {
                                    src:
                                      scope.row.abbreviationImage ||
                                      scope.row.attrImage,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.previewImg(scope.row.attrImage)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "SKU编码",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "SKU名称",
                  "min-width": "90",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "specificationsName",
                  label: "规格",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cateName",
                  label: "商品分类",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "otPrice", label: "原价", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                directives: [
                  {
                    name: "has-permini",
                    rawName: "v-has-permini",
                    value: ["supplyPrice"],
                    expression: "['supplyPrice']",
                  },
                ],
                attrs: { prop: "supplyPrice", label: "成本价", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "taxRate", label: "进项税率", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "guidePrice", label: "指导价", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "defaultPrice", label: "默认售价", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                directives: [
                  {
                    name: "has-permini",
                    rawName: "v-has-permini",
                    value: ["grossMargin"],
                    expression: "['grossMargin']",
                  },
                ],
                attrs: { prop: "grossMargin", label: "毛利率", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "areaName",
                  label: "产地",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                directives: [
                  {
                    name: "has-permini",
                    rawName: "v-has-permini",
                    value: ["supplierName"],
                    expression: "['supplierName']",
                  },
                ],
                attrs: {
                  prop: "supplierName",
                  label: "供应商",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                directives: [
                  {
                    name: "has-permini",
                    rawName: "v-has-permini",
                    value: ["supplierName"],
                    expression: "['supplierName']",
                  },
                ],
                attrs: {
                  prop: "supplierMaintainerName",
                  label: "维护人",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cpStatusName",
                  label: "采销状态",
                  width: "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "listStatus", label: "上架状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "上架",
                            "inactive-text": "下架",
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeListStatus(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.listStatus,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "listStatus", $$v)
                            },
                            expression: "scope.row.listStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "small" },
                          on: {
                            input: function ($event) {
                              return _vm.inputStock(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.stock,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "stock", $$v)
                            },
                            expression: "scope.row.stock",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          directives: [
                            {
                              name: "has-permini",
                              rawName: "v-has-permini",
                              value: ["admin:store:sku:updateSort"],
                              expression: "['admin:store:sku:updateSort']",
                            },
                          ],
                          attrs: { size: "small" },
                          on: {
                            input: function ($event) {
                              return _vm.inputSort(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.sort,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "sort", $$v)
                            },
                            expression: "scope.row.sort",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyName",
                  label: "审核状态",
                  width: "100",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isVerify == 1
                          ? _c("span", { staticStyle: { color: "#67C23A" } }, [
                              _vm._v(_vm._s(scope.row.verifyName)),
                            ])
                          : scope.row.isVerify == -1
                          ? _c(
                              "span",
                              { staticStyle: { color: "#F56C6C" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.verifyName) +
                                    "\n              "
                                ),
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      trigger: "hover",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "失败原因: " +
                                          _vm._s(scope.row.verifyReason)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { color: "#E6A23C" },
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  原因\n                  "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("span", { staticStyle: { color: "#409EFF" } }, [
                              _vm._v(_vm._s(scope.row.verifyName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "价格变动", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "#F56C6C" } }, [
                          _vm._v(
                            _vm._s(
                              scope.row.newSupplyPrice -
                                scope.row.oldSupplyPrice >
                                0
                                ? "上调￥" +
                                    (Number(scope.row.newSupplyPrice) -
                                      Number(scope.row.oldSupplyPrice).toFixed(
                                        2
                                      )) +
                                    "元 ↑"
                                : ""
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { color: "#67C23A" } }, [
                          _vm._v(
                            _vm._s(
                              scope.row.newSupplyPrice -
                                scope.row.oldSupplyPrice <
                                0
                                ? "下调￥" +
                                    (Number(scope.row.oldSupplyPrice) -
                                      Number(scope.row.newSupplyPrice).toFixed(
                                        2
                                      )) +
                                    "元 ↓"
                                : ""
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.newSupplyPrice -
                                scope.row.oldSupplyPrice ==
                                0
                                ? "未变动"
                                : ""
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "140",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              !_vm.userType
                ? _c("el-table-column", {
                    attrs: {
                      prop: "createName",
                      label: "操作人",
                      "min-width": "100",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "190", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:store:product:updateCpStatus"],
                                expression:
                                  "['admin:store:product:updateCpStatus']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCpStatus(scope.row)
                              },
                            },
                          },
                          [_vm._v("采销状态")]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                path:
                                  "/store/list/creatProduct/" +
                                  scope.row.productId,
                                query: { source: "sku" },
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:product:sku:update"],
                                    expression: "['admin:product:sku:update']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { type: "text", size: "small" },
                              },
                              [_vm._v("编辑")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:product:sku:delete"],
                                expression: "['admin:product:sku:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(
                                  scope.row.id,
                                  _vm.tableFrom.type
                                )
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c(
                "div",
                { staticClass: "btns" },
                [
                  _c(
                    "ButtonUploadExcelVue",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:store:product:import:change:price"],
                          expression:
                            "['admin:store:product:import:change:price']",
                        },
                      ],
                      attrs: { beforeUpload: _vm.uploadFile },
                    },
                    [_vm._v("导入修改指导价与默认售价")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:store:product:sync"],
                          expression: "['admin:store:product:sync']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.updateProductLibrary },
                    },
                    [_vm._v("同步到产品库")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.pageData.limit,
                  "current-page": _vm.pageData.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("ChanageCpStatus", {
            ref: "ChanageCpStatusRef",
            on: { refresh: _vm.getList },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("AuditSpuOrSku", {
        ref: "auditSpuOrSkuRef",
        on: { auditEdit: _vm.getList },
      }),
      _vm._v(" "),
      _c("PriceAdjustment", { ref: "priceAdjustmentItemRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }